import { map, mapValues, orderBy } from "lodash";
import { useMemo } from "react";
import useGetForwardLookingV4 from "./Projections/useGetForwardLookingV4";
import useGetHistoricalV4 from "./Projections/useGetHistoricalV4";
import useGetProjectionsV4 from "./Projections/useGetProjectionsV4";
import useGetScenariosV4 from "./Projections/useGetScenariosV4";
import useGetAccountGroupsForTimeFrameV4 from "./useGetAccountGroupForTimeFrameV4";
export default function useAccountGroupProjectionsV4(accountGroupId, clientId, authConfig) {
    const accountGroups = useGetAccountGroupsForTimeFrameV4(accountGroupId, "30D", null, clientId, authConfig);
    const projections = useGetProjectionsV4(accountGroupId, authConfig);
    const historical = useGetHistoricalV4(accountGroupId, authConfig);
    const forwardLooking = useGetForwardLookingV4(accountGroupId, authConfig);
    const scenarios = useGetScenariosV4(accountGroupId, authConfig);
    const result = useMemo(() => {
        const isAnyLoading = accountGroups.isLoading ||
            projections.isLoading ||
            historical.isLoading ||
            forwardLooking.isLoading ||
            scenarios.isLoading;
        const anyHasError = accountGroups.hasError ||
            projections.hasError ||
            historical.hasError ||
            forwardLooking.hasError ||
            scenarios.hasError;
        if (anyHasError) {
            return {
                data: undefined,
                isLoading: false,
                hasError: true,
                error: accountGroups.hasError
                    ? accountGroups.error
                    : projections.hasError
                        ? projections.error
                        : historical.hasError
                            ? historical.error
                            : forwardLooking.hasError
                                ? forwardLooking.error
                                : scenarios.hasError
                                    ? scenarios.error
                                    : new Error("Unknown error"),
            };
        }
        if (isAnyLoading) {
            return { data: undefined, isLoading: isAnyLoading, hasError: false };
        }
        const sorted = orderBy(accountGroups.data.balanceSummary, [(b) => b.date], ["desc"]);
        const yesterdayStartingValue = sorted[1]?.balance ?? 0;
        const projectedBalances = mapValues(projections.data.monteCarloSimulationResults, (simulation) => orderBy(map(simulation, (growth, year) => [parseInt(year), growth * yesterdayStartingValue]), [(s) => s[0]], ["asc"]));
        const riskiness = historical.data.finScore;
        const { securityReplacements: _s1, securitiesRemoved: _s2, ...onlyScenarios } = scenarios.data;
        const expectedReturns = forwardLooking.data.expectedReturns;
        const expectedVolatility = forwardLooking.data.expectedVolatility;
        return {
            data: {
                projections: projectedBalances,
                riskiness,
                expectedReturns: expectedReturns,
                expectedVolatility: expectedVolatility,
                sharpeRatio: expectedReturns === null || expectedVolatility === null
                    ? null
                    : safeDivide(expectedReturns, expectedVolatility),
                scenarios: onlyScenarios,
            },
            isLoading: false,
            hasError: false,
        };
    }, [accountGroups, forwardLooking, historical, projections, scenarios]);
    return result;
}
function safeDivide(a, b) {
    if (b === 0) {
        return 0;
    }
    return a / b;
}
//# sourceMappingURL=usePerformanceGroupProjectionsV4.js.map